import AppleSignin from "react-apple-signin-auth";
import { useSearchParams } from "next/navigation";

import { AppleIcon } from "@/components/security/login/components/apple-auth/apple-icon";
import { Button } from "@/components/ui/button";

export const AppleAuth = () => {
  const searchParams = useSearchParams();

  return (
    <AppleSignin
      /** Auth options passed to AppleID.auth.init() */
      authOptions={{
        clientId: "md.remedium.web",
        scope: "email name",
        redirectURI: "https://remedium.md/login/apple-auth",
        // Apple odsyła `state` w POST na redirectURI — tak przenosimy `?redirect=` (np. powrót do OAuth).
        // Prefiks `web:` odróżnia stronę od apki na Androidzie (ten sam clientId i redirectURI, apka nie wysyła `state`).
        state: `web:${searchParams.get("redirect") ?? ""}`,
        usePopup: false,
      }} // REQUIRED
      onSuccess={(response) => {
        location.reload();
      }} // default = undefined
      onError={(error) => console.error(error)} // default = undefined
      render={(props) => (
        <Button
          {...props}
          variant={"outline"}
          className={
            "hover:[&_svg_rect]:fill-secondary! w-full overflow-hidden [&_svg]:h-[44px]! [&_svg]:w-[44px]! [&_svg_rect]:transition-all"
          }
          type="button"
          aria-label="Signin with apple ID"
        >
          <AppleIcon />
          Zaloguj się przez Apple
        </Button>
      )}
    />
  );
};
